module.exports = __webpack_public_path__ + "img/p20.e4c6ce7d.png";